import { Language, RequestPhotoStatus } from '^/types';

const { PENDING, REQUESTED, COMPLETED, FAILED, READY }: typeof RequestPhotoStatus =
  RequestPhotoStatus;

export default {
  [PENDING]: {
    [Language.EN_US]: 'Draft',
    [Language.KO_KR]: '초안',
  },
  [REQUESTED]: {
    [Language.EN_US]: 'Requested',
    [Language.KO_KR]: '요청중',
  },
  [COMPLETED]: {
    [Language.EN_US]: 'Completed',
    [Language.KO_KR]: '완료됨',
  },
  [FAILED]: {
    [Language.EN_US]: 'Failed',
    [Language.KO_KR]: '실패',
  },
  [READY]: {
    [Language.EN_US]: 'Needs Review',
    [Language.KO_KR]: '검토 필요',
  },
};
